import { motion } from "framer-motion";

export default function SectionHeader({ eyebrow, title, subtitle, align = "left", testId }) {
  const items = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col ${items} max-w-3xl ${align === "center" ? "mx-auto" : ""}`} data-testid={testId}>
      {eyebrow && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          className="flex items-center gap-3 mb-5"
        >
          <motion.span
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            style={{ transformOrigin: align === "center" ? "center" : "left" }}
            className="block h-px w-10 bg-[#B8873B]"
          />
          <span className="text-[10px] tracking-[0.5em] uppercase text-[#B8873B]">{eyebrow}</span>
        </motion.div>
      )}
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="font-display font-light text-4xl md:text-6xl leading-[1.02]"
      >
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-6 text-base md:text-lg text-white/65 font-light leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
